import { render, staticRenderFns } from "./KnowledgeBaseDocuments.vue?vue&type=template&id=040b1ed8&scoped=true"
import script from "./KnowledgeBaseDocuments.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseDocuments.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseDocuments.vue?vue&type=style&index=0&id=040b1ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b1ed8",
  null
  
)

export default component.exports